"use strict";
exports.__esModule = true;
exports.INCOME_VERIFICATION_PROCESSING_OFFER = void 0;
exports.INCOME_VERIFICATION_PROCESSING_OFFER = {
    HEADER: 'We’re on it!',
    BODY_1: 'Thanks for submitting your application.',
    BODY_2: 'Please allow up to 3 business days for us to review your application. We’ll email you once it’s complete.'
};
